// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderMobileMenu: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 16" width={width} height={height}>
            <path
                fill="currentColor"
                d="M0 .727C0 .327.29 0 .643 0h16.714c.354 0 .643.327.643.727s-.29.728-.643.728H.643C.289 1.455 0 1.127 0 .727M0 8c0-.4.29-.727.643-.727h16.714c.354 0 .643.327.643.727s-.29.727-.643.727H.643C.289 8.727 0 8.4 0 8m18 7.273c0 .4-.29.727-.643.727H.643C.289 16 0 15.673 0 15.273s.29-.728.643-.728h16.714c.354 0 .643.328.643.728"
            />
        </svg>
    );
};

export default React.memo(HeaderMobileMenu);
